/**
 * StockSettingsTab - Aba "Gestão Rastreador" das Configurações do tenant
 *
 * Liga/desliga a Gestão Rastreador (rastreadores, chips e kits).
 * Somente administradores; a validação real acontece na RPC.
 *
 * RELEASE: 2026-10-10 v1.1.0 - Renomeia a apresentação e desvincula Pessoas da descrição.
 * RELEASE: 2026-10-06 v1.0.0 - Criação inicial (Fase 2 do Estoque).
 */
import { Boxes } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { Skeleton } from '@/components/ui/skeleton';
import { SettingsCard, SettingsSectionHeader } from '@/components/tenant/SettingsInfoRow';
import { useStockModule } from '@/hooks/useStockModule';

export function StockSettingsTab() {
  const { isEnabled, isLoading, toggleModule } = useStockModule();
  if (isLoading) return <Skeleton className="h-40 w-full rounded-lg" />;

  return (
    <SettingsCard>
      <SettingsSectionHeader
        eyebrow="Módulo"
        title="Gestão Rastreador"
        description="Controle de rastreadores, chips e kits, com seus modelos e endereços de estoque."
      />
      <div className="flex items-center justify-between gap-4 px-6 py-4">
        <div className="flex items-start gap-3">
          <Boxes className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
          <div className="space-y-1 text-sm">
            <p className="font-medium text-foreground">Habilitar módulo Gestão Rastreador</p>
            <p className="text-muted-foreground">Desligar esconde o menu, mas nenhum cadastro é apagado.</p>
          </div>
        </div>
        <Switch
          checked={isEnabled}
          disabled={toggleModule.isPending}
          onCheckedChange={(v) => toggleModule.mutate(v)}
          aria-label="Habilitar módulo Gestão Rastreador"
        />
      </div>
    </SettingsCard>
  );
}
